var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.949,
    height: 75.083,
    viewBox: "0 0 74.949 75.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call",
    transform: "translate(0.391 1.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7196",
    "data-name": "Path 7196",
    d: "M45.274,14.344A16.68,16.68,0,0,1,58.451,27.521M45.274,1A30.024,30.024,0,0,1,71.795,27.488M68.459,54.109V64.117a6.672,6.672,0,0,1-7.273,6.672A66.02,66.02,0,0,1,32.4,60.548,65.052,65.052,0,0,1,12.381,40.532,66.02,66.02,0,0,1,2.139,11.609,6.672,6.672,0,0,1,8.778,4.336H18.786a6.672,6.672,0,0,1,6.672,5.738,42.834,42.834,0,0,0,2.335,9.374,6.672,6.672,0,0,1-1.5,7.039l-4.237,4.237A53.376,53.376,0,0,0,42.071,50.74L46.308,46.5A6.672,6.672,0,0,1,53.347,45a42.834,42.834,0,0,0,9.374,2.335,6.672,6.672,0,0,1,5.738,6.772Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.49809e41e516824fe1a06827ccd16428.svg";
export { ForwardRef as ReactComponent };